"use client"; // Error boundaries must be Client Components
import { useEffect } from "react";

export default function ErrorPage({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error(error);
  }, [error]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "2rem"
      }}
    >
      <h3>Something went wrong!</h3>
      <p>Please do not send a screenshot of this generic message.</p>
      <p>
        Report any actions you took before the error occurred to the <code>#army-forge-issues</code> channel
        on the OPR Community Discord, as well as:
      </p>
      <ul style={{ paddingLeft: "1rem" }}>
        <li>
          Any errors in your browser console. On desktop press <code>F12 -&gt; Console</code>
        </li>
        <li>The URL of the page</li>
      </ul>
    </div>
  );
}
